import { ImplementationDto } from "./ImplementationDto";
import { PaymentStatusDto } from "./PaymentStatusDto";
import { RequestStatusDto } from "./RequestStatusDto";
import { ServiceCategoryDto } from "./ServiceCategoryDto";
import { ServiceDto } from "./ServiceDto";

export class FilterOrderDetail {
  requestStatuses: RequestStatusDto[];
  filteredRequestStatuses: RequestStatusDto[];
  paymentStatuses: PaymentStatusDto[];
  serviceCategories: ServiceCategoryDto[];
  services: ServiceDto[];
  implementations: ImplementationDto[];
}
